/*
name: Enum name,
label: Message on the screen
severity: level of message, [error, warning, success ]
cleanOnChange:default:true.  if false, doesn't effect on reset message, message always stay on list
single: Message not counted on Message Text, writen as flat
    not single --> 100 On click action not defined (0,1,2,3,4...)
    single --> Firebase Configuration Failed
showMessages: default: true, show message or not
*/
export default {
    projectMissingAddress: {
        name: 'projectMissingAddress',
        label: 'Projects without an Address or Geolocation ',
        severity: 'error'
    },
    couldNotGeolocated: {
        name: 'couldNotGeolocated',
        label: 'Projects could not be geo-located',
        severity: 'error'
    },
    unknownError: {
        name: 'unKnownError',
        label: 'An unknown error has occurred',
        severity: 'error'
    },
    projectIdNotFound: {
        name: 'projectIdNotFound',
        label: 'ProjectId Information Not Found',
        severity: 'error'
    },
    codeNotFound: {
        name: 'codeNotFound',
        label: 'Code Information Not Found',
        severity: 'error'
    },
    nameNotFound: {
        name: 'nameNotFound',
        label: 'Name Information Not Found',
        severity: 'error'
    },
    captionNotFound: {
        name: 'captionNotFound',
        label: 'Caption Information Not Found',
        severity: 'error'
    },
    imagePathNotFound: {
        name: 'imagePathNotFound',
        label: 'ImagePath Information Not Found',
        severity: 'error'
    },
    discriminatorNotFound: {
        name: 'discriminatorNotFound',
        label: 'Discriminator Information Not Found',
        severity: 'error'
    },
    onClickActionNotFound: {
        name: 'onClickActionNotFound',
        label: 'On click action not defined',
        severity: 'error'
    },
    onClickActionNotAllowed: {
        name: 'onClickActionNotAllowed',
        label: 'On click action not allowed',
        severity: 'error'
    },
    geolocationFailure: {
        name: 'geolocationFailure',
        label: 'Geolocation Failure',
        severity: 'error'
    },
    geocodeFailure: {
        name: 'geocodeFailure',
        label: 'Geocode Failure',
        severity: 'error'
    },
    geolocationSucceed: {
        name: 'geolocationSucceed',
        label: 'Geolocation Succedd',
        severity: 'success',
        showMessages: false
    },
    geocodeSucceed: {
        name: 'geocodeSucceed',
        label: 'Geocode Succeed',
        severity: 'success',
        showMessages: false
    },
    addressNotProvided: {
        name: 'addressNotProvided',
        label: 'Address or Geolocation not Provided',
        severity: 'error'
    },
    noAPIKey: {
        name: 'noAPIKey',
        label: 'Google API Key not found',
        severity: 'error',
        single: true
    },
    invalidAPIKey: {
        name: 'invalidAPIKey',
        label: 'Invalid Google API Key',
        severity: 'error',
        single: true
    },
    stylesNotProvided: {
        name: 'stylesNotProvided',
        label: 'Style Configuration File not Found',
        severity: 'warning'
    },
    memoryAllocated: {
        name: 'memoryAllocated',
        label: "Memory Limit Allocated. File couldn't be saved.",
        severity: 'warning'
    },
    serverConfigurationFailed: {
        name: 'serverConfigurationFailed',
        label: 'Firebase Configuration Failed',
        severity: 'error',
        cleanOnChange: false,
        single: true
    }
};
